import React, { useState, useEffect } from "react";
import SC from "../style";
import theme from "@theme";
import { Checkbox } from "@mui/material";

const ProjectList = (props) => {
  const {
    projectData = [],
    checkedProjects = [],
    setCheckedProjects = () => {},
  } = props;
  const [searchTerm, setSearchTerm] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");
  // const [isInitialized, setIsInitialized] = useState(false);


  // useEffect(() => {
  //   if (
  //     !isInitialized &&
  //     projectData.length > 0 &&
  //     checkedProjects.length == 0
  //   ) {
  //     setCheckedProjects(projectData.map((item) => item.id));
  //     setIsInitialized(true);
  //   }
  // }, [isInitialized, projectData, checkedProjects, setCheckedProjects]);

  // Sort toggle
  const handleSort = () => {
    setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
  };

  // Individual checkbox toggle
  const handleCheckboxChange = (id) => {
    setCheckedProjects((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id]
    );
  };

  // Select/Deselect all
  const handleSelectAll = () => {
    if (areAllSelected) {
      setCheckedProjects([]);
    } else {
      const allIds = filteredProjects.map((item) => item.id);
      setCheckedProjects(allIds);
    }
  };

  // Sorting logic
  const sortedRoles = [...projectData].sort((a, b) => {
    const roleA = a.propertyName.toLowerCase();
    const roleB = b.propertyName.toLowerCase();
    return sortDirection === "asc"
      ? roleA.localeCompare(roleB)
      : roleB.localeCompare(roleA);
  });

  const filteredProjects = sortedRoles.filter((item) =>
    item.propertyName
      .replace(/\s/g, "")
      .toLowerCase()
      .includes(searchTerm.replace(/\s/g, "").toLowerCase())
  );

  const areAllSelected =
    filteredProjects.length > 0 &&
    filteredProjects.every((item) => checkedProjects.includes(item.id));

  return (
    <>
      <SC.TitleConatiner>
        <div style={{ marginBottom: "10px" }}>
          <SC.Title>Select Projects to Apply Changes</SC.Title>
          <SC.Description>
            Choose the projects where you want to reflect the updated folder
            template. Only selected projects will inherit the new structure.
          </SC.Description>
        </div>
        <SC.InputContiner>
          <SC.SearchIcon />
          <SC.InputStyle
            placeholder="Search project"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </SC.InputContiner>
      </SC.TitleConatiner>

      <SC.Container>
        <SC.Table>
          <SC.Thead>
            <SC.Trheader>
              <SC.Th> S. No. </SC.Th>
              <SC.ThRole>
                Project List
                <SC.SwapVertIcon onClick={handleSort} />
              </SC.ThRole>
              <SC.Th>
                <Checkbox
                  checked={areAllSelected}
                  onChange={handleSelectAll}
                  sx={{
                    "&.Mui-checked": {
                      color: theme.colors.themeColor,
                    },
                  }}
                  size="small"
                />
              </SC.Th>
            </SC.Trheader>
          </SC.Thead>
          <SC.Tbody>
            {filteredProjects.length === 0 ? (
              <SC.Tr>
                <SC.Td
                  colSpan={4}
                  style={{ textAlign: "center", padding: "16px" }}
                >
                  No data
                </SC.Td>
              </SC.Tr>
            ) : (
              filteredProjects.map((item, index) => (
                <SC.Tr key={item.id}>
                  <SC.Td>{index + 1}</SC.Td>
                  <SC.TdRole>{item.propertyName}</SC.TdRole>
                  <SC.Td>
                    <Checkbox
                      checked={checkedProjects.includes(item.id)}
                      onChange={() => handleCheckboxChange(item.id)}
                      sx={{
                        "&.Mui-checked": {
                          color: theme.colors.themeColor,
                        },
                      }}
                      size="small"
                    />
                  </SC.Td>
                </SC.Tr>
              ))
            )}
          </SC.Tbody>
        </SC.Table>
      </SC.Container>
    </>
  );
};

export default ProjectList;
